import Linkable from '@inkline/inkline/src/components/ILinkable';

export default {
    name: 'INavbarBrand',
    extends: Linkable
};
